const DEFAULT_LAYOUT_REDUX_STATE = {
  page: null,
  subPage: null,
};

export default DEFAULT_LAYOUT_REDUX_STATE;
